import axios from 'axios';
import {
  visaOptions
} from '@/config';

export default {
  getAddons({
    state,
    commit
  }) {
    commit('setLoading', true);

    return axios
      .get(state.data.addons.dataUrl, {
        params: {
          departureId: state.quote.departureId,
          filo: state.quote.filo,
          transportCode: state.quote.departureTransportCode,
          tourCode: state.quote.tourCode
        }
      })
      .then(response => {
        commit('setAddonData', response.data);
        commit('setLoading', false);
      })
      .catch(() => {
        commit('setError', true);
      });
  },

  getDepartureDetails({
    state,
    commit
  }) {
    commit('setLoading', true);

    return axios
      .get(state.data.flights.dataUrl, {
        params: {
          departureId: state.quote.departureId,
          filo: state.quote.filo,
          transportCode: state.quote.departureTransportCode
        }
      })
      .then(response => {
        commit('setDepartureDetails', response.data);
        commit('setLoading', false);
      })
      .catch(() => {
        commit('setError', true);
      });
  },

  getAvailableRooms({
    state,
    commit
  }) {
    return axios
      .get(state.data.travellers.roomsDataUrl, {
        params: {
          departureId: state.quote.departureId,
          filo: state.quote.filo,
          transportCode: state.quote.departureTransportCode
        }
      })
      .then(response => {
        commit('setAvailableRooms', response.data.rooms);
        commit('setMaxiumumPassengers', response.data.maxAvailable);
      })
      .catch(() => {
        commit('setError', true);
      });
  },

  rooms({
    state,
    commit,
    getters,
    dispatch
  }) {
    commit('setLoading', true);

    return axios
      .post(state.data.travellers.submitUrl, {
        ...state.quote,
        passengers: getters.roomPassengers,
        donatingTravellers: getters.donatingTravellers,
        donationExtraId: getters.donationExtraId,
        donationAllocationType: getters.donationAllocationType,
        donationForBooking: getters.donationPerBooking
      })
      .then(response => {
        commit('setQuote', response.data);
        commit('setQuoteDonations');
        dispatch('hydrateRoomsFromApi');
        commit('resetExcursions');
        commit('resetPassengers');
        commit('setSubtotalMismatch', getters.runningSubtotal);
        commit('setDonationMade', response.data.donationMade);
        commit('setLoading', false);
      })
      .catch(() => {
        const leadPassanger = getters.roomPassengers.filter(rp => rp.lead)[0];
        const firstName = leadPassanger.firstName;
        const lastName = leadPassanger.lastName;
        const tourName = state.data.tourName.replace(/\s/g,'-');
        const departureDate = state.departureDetails.departureLegs[0].departureTime.date.replace(/\s/g,'-');
        const quoteId = state.quote.quoteId;
        
        let url = `${window.origin}/booking-failed-contact-form/?firstName=${firstName}&lastName=${lastName}&tourName=${tourName}&departureDate=${departureDate}`;

        if (quoteId !== 0) {
          url += `&quoteId=${quoteId}`;
        }

        window.location.href = url;
      });
  },

  /**
   * we hydrate rooms from the returned API data
   * this ensures we get passengerIds in our frontend rooms array
   * which allows us to keep "passengerDetails" when navigating back and forward through the checkout
   */
  hydrateRoomsFromApi({
    state,
    commit,
    rootGetters
  }) {
    state.rooms.forEach(room => {
      // loop the room passengers
      // match the passenger to quote.passengers using (roomId / firstName / lastName)
      room.passengers.forEach(roomPassenger => {
        const roomPassengerData = rootGetters.formDataFlat(roomPassenger);
        const matchingQuotePassenger = state.quote.passengers.find(quotePassenger => {
          return quotePassenger.roomId === room.id && quotePassenger.firstName === roomPassengerData.firstName && quotePassenger.lastName === roomPassengerData.lastName;
        });
        if (matchingQuotePassenger) {
          commit('setRoomPassengerId', {
            roomPassenger,
            passengerId: matchingQuotePassenger.passengerId
          });
        }
      });
    });
  },

  getExcursions({
    state,
    commit
  }) {
    commit('setLoading', true);

    return axios
      .get(state.data.excursions.dataUrl, {
        params: {
          departureId: state.quote.departureId
        }
      })
      .then(response => {
        commit('setExcursionData', response.data);
        commit('setLoading', false);
      })
      .catch(() => {
        commit('setError', true);
      });
  },

  getDonations({
    state,
    commit
  }) {
    commit('setLoading', true);
    return axios
      .get(state.data.donations.dataUrl, {
        params: {
          departureId: state.quote.departureId
        }
      })
      .then(response => {
        commit('setDonationsData', response.data);
        commit('setLoading', false);
      })
      .catch(() => {
        commit('setError', true);
      });
  },

  excursions({
    state,
    commit,
    getters
  }) {
    commit('setLoading', true);

    return axios
      .post(state.data.excursions.submitUrl, {
        ...state.quote,
        excursions: getters.excursions
      })
      .then(response => {
        commit('setQuote', response.data);
        commit('setQuoteDonations');
        commit('setSubtotalMismatch', getters.runningSubtotal);
        commit('setLoading', false);
      })
      .catch(() => {
        commit('setError', true);
      });
  },

  handleExcursionChange({
    state,
    commit
  }) {
    // compare state.excursions to state.quote.excursions
    if (JSON.stringify(state.excursions) !== JSON.stringify(state.quote.excursions)) {
      // If different, reset payment and reopen passenger information
      commit('resetPayment');

      // for each passenger index
      for (let i = 0; i < state.passengers.length; i++) {
        commit('unsetHasBeenSubmitted', ['checkout', 'passengers', i], {
          root: true
        });
        commit('unsetSummaryView', ['checkout', 'passengers', i], {
          root: true
        });
      }

      axios.cancel('passengers');
    }
  },

  getVisas({
    state,
    commit
  }) {
    return axios
      .get(state.data.passengerDetails.visaDataUrl, {
        params: {
          departureId: state.quote.departureId,
          filo: state.quote.filo
        }
      })
      .then(response => {
        commit('setVisas', response.data);
      })
      .catch(() => {
        commit('setError', true);
      });
  },

  getLoggedInPassengerData({
    state,
    commit
  }) {
    return axios
      .get(state.data.login.userDetailsUrl)
      .then(response => {
        commit('setloggedInPassengerData', response.data);
      })
      .catch(error => {
        console.warn(error);
      });
  },

  generateToken({
    state,
    commit
  }) {
    return axios
      .post(state.data.login.generateTokenUrl)
      .then(response => {        
        window.__RequestVerificationToken = response.data;
      })
      .catch(error => {
        console.warn(error);
      });
  },

  passengers({
    state,
    commit,
    getters
  }) {

    commit('setPaymentLoading', true);

    // build passenger data to send to API
    const passengers = getters.passengersDetails.map(passenger => {
      const passengerData = {
        ...passenger,
        visaIds: []
      }

      if (passengerData.address) {
        passengerData.address.addressLines = Object.keys(passengerData.address.addressLines).map(k => passengerData.address.addressLines[k]);
      }

      if (passenger.visaIds) {
        for (const visaId in passenger.visaIds) {
          if (passenger.visaIds[visaId] === visaOptions.required) {
            passengerData.visaIds.push(parseInt(visaId));
          }
        }
      }

      return passengerData;
    });

    return axios
      .post(state.data.passengerDetails.submitUrl, {
        ...state.quote,
        passengers
      }, {
        requestId: 'passengers'
      })
      .then(response => {
        // ensure all passengers are complete before doing this
        commit('setPayment', response.data);
        commit('setPaymentLoading', false);
      })
      .catch((thrown) => {
        if (!axios.isCancel(thrown)) {
          commit('setError', true);
        }
      });
  },

  payment({
    state,
    commit,
    getters
  }) {
    commit('setLoading', true);

    return axios
      .post(state.data.payment.submitUrl, getters.paymentData)
      .then(response => {
        commit('setPaymentFrame', response.data);
        commit('setLoading', false);
      })
      .catch(() => {
        commit('setError', true);
      });
  },

  paymentStatus({
    state,
    commit,
    dispatch
  }) {
    commit('setLoading', true);

    return axios
      .get(state.data.payment.statusCheckUrl, {
        params: {
          transactionId: state.quote.transactionId
        }
      })
      .then(response => {
        // keep polling the status endpoint until its success/failure
        if (response.data.status === 'pending') {
          dispatch('paymentStatus');
        }
        // set errors from the response
        else if (response.data.status === 'error') {
          // TODO: Pass [response.data.error] through to error message
          commit('setError', true);
        }
        // hit the confirm booking url
        else {
          dispatch('confirmBooking');
        }
      })
      .catch(() => {
        commit('setError', true);
      });
  },

  confirmBooking({
    state,
    commit
  }) {
    commit('setLoading', true);

    return axios
      .post(state.data.booking.confirmBookingSubmitUrl, {
        transactionId: state.quote.transactionId,
        quoteId: state.quote.quoteId,
        takeFinalBalance: state.quote.takeFinalBalance
      })
      .then(response => {
        // set errors from the response
        if (!response.data.success) {
          // TODO: Pass [response.data.error] through to error message
          commit('setError', true);
        } else {
          commit('setBookingReference', response.data.bookingReference);

          // check if we have full booking details (NOT reservation mode)
          if (response.data.bookingDetails) {
            commit('setBooking', response.data.bookingDetails);
            commit('setLoading', false);
          }
        }
      })
      .catch(error => {
        commit('setError', true)

        if (error.response.data && error.response.data.type === 'UserFriendlyError') {
          commit('setErrorMessage', error.response.data.message);
        }
      });
  }
}
